import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-261a7690"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Welcome!", -1))
const _hoisted_3 = { class: "form-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "chat-response-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "draw-response-wrapper"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.promptText) = $event)),
          placeholder: "Enter a prompt...",
          rows: "3",
          cols: "60"
        }, null, 512), [
          [_vModelText, _ctx.promptText]
        ]),
        _hoisted_4,
        _createElementVNode("button", {
          class: "button-30",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.chatWithMe && _ctx.chatWithMe(...args)), ["prevent"]))
        }, "Chat"),
        _createElementVNode("button", {
          class: "button-30",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.drawWithMe && _ctx.drawWithMe(...args)), ["prevent"]))
        }, "Draw")
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.chatResponseText), 1),
    (_ctx.drawResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawResponse.data, (image) => {
            return (_openBlock(), _createElementBlock("div", {
              key: image.url,
              class: "single-image"
            }, [
              _createElementVNode("img", {
                src: image.url
              }, null, 8, _hoisted_7)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.drawResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawResponse.data, (image, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("a", {
                href: image.url,
                target: "_blank"
              }, "Image: " + _toDisplayString(index), 9, _hoisted_9)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "button-30",
        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateConfig && _ctx.updateConfig(...args)), ["prevent"]))
      }, "Update Joystick Config")
    ]),
    _createElementVNode("div", null, _toDisplayString(_ctx.updateJoystickConfigStatus), 1)
  ]))
}